import { api } from '@/services'
import { findAll, list, show, createUpdate, remove } from './partnerServices'

import {
  getSignedUrl,
  uploadToS3,
} from '@/services/upload/uploadService'

async function partnerLogoUploader(payload) {
  try {
    await getSignedUrl({
      filename: payload.file.name,
      filetype: payload.file.type,
      partner_id: payload.partnerId,
    }, '/admin/partner/logoUploadURL')
      .then(async ({ signedUrl, external_filename}) => {
        await uploadToS3(signedUrl, payload.file)
          .then(() => {
            const attachData = {
              external_filename: external_filename,
              external_url: signedUrl.substring(0, signedUrl.indexOf('?')),
              filename: payload.file.name,
              partner_id: payload.partnerId,
            }

            return attachData
          })
          .then(async (attachData) => { await api.post('admin/partner/addLogo ', attachData) })
          .catch((error) => { console.log(error) })
        })
      .catch((error) => { console.log(error) })
  } catch (errors) {
    return errors
  }
}

const state = {
  partners: [],
  partner: {},
}

const getters = {
  partners: (state) => state.partners,
  partner: (state) => state.partner,
}

const actions = {
  async fetchAllPartners({ commit, dispatch }) {
    commit('setIsLoading', true)

    try {
      const { data } = await findAll()
      commit('setPartners', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  fetchPartners({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)
    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }
    const params = { ...defaultParams, ...rootState.filters.filters }

    list(params)
      .then(({ data }) => {
        const { result, total } = data
        commit('setPartners', result)
        commit('setTotalPages', total)
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  fetchPartner({ commit, dispatch }, id) {
    commit('setIsLoading', true)

    show(id)
      .then(({ data }) => {
        commit('setPartner', data)
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  createUpdatePartner({ commit, dispatch }, body) {
    commit('setIsLoading', true)

    createUpdate(body)
      .then(({ data }) => {
        commit('setPartner', data)
        dispatch('fetchPartners')
        commit('closeAllModals')

        const payload = {
          partnerId: data.id,
          file: body.logo,
        }

        partnerLogoUploader(payload)
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  removePartner({ commit, dispatch }, id) {
    commit('setIsLoading', true)

    remove(id)
      .then(() => {
        dispatch('fetchPartners')
        commit('closeAllModals')
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  handleOpenCreateEditPartnerModal({ dispatch, commit }, id) {
    commit('setPartner', {})
    dispatch('openModal', 'CREATE_UPDATE_PARTNER_MODAL')
    id && dispatch('fetchPartner', id)
  },

  handleDeletePartnerModal({ dispatch, commit }, id) {
    commit('setPartner', {})
    dispatch('openModal', 'DELETE_PARTNER_MODAL')
    id && dispatch('fetchPartner', id)
  },
}

const mutations = {
  setPartners: (state, partners) => {
    state.partners = partners
  },
  setPartner: (state, partner) => {
    state.partner = partner
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
